import * as classnames from 'classnames';
import * as React from 'react';

import { History } from 'history';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { logout } from 'actions/account';
import { LayoutActionCreators } from 'actions/layout';
import { FlashMessage } from 'components/FlashMessage';
import { LayoutSidemenu } from 'components/Layout';
import { LoaderBlock } from 'components/Loader';
import { AppState } from 'models/app';
import { FlashMessageModifier, FlashMessageParam } from 'models/flashMessage';
import { LayoutState } from 'models/layout';

import './Layout.scss';

interface StateProps {
  flashMessageIsOpen: boolean;
  flashMessageModifier: FlashMessageModifier;
  flashMessageParam?: FlashMessageParam;
  flashMessageText: string;
  isLoading: boolean;
  isAuthenticated: boolean;
  layout: LayoutState;
}

interface DispatchProps {
  logout: typeof logout;
  toggleMenu: typeof LayoutActionCreators.toggleMenu.create;
}

interface OwnProps {
  history: History;
  modifier?: 'off-white';
}

type LayoutProps = StateProps & DispatchProps & OwnProps;

class LayoutContainer extends React.Component<LayoutProps, {}> {
  constructor(props: LayoutProps) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  render() {
    const { children, isLoading, isAuthenticated, modifier } = this.props;
    const classNameModifier = modifier && 'layout--' + modifier;
    return (
      <LoaderBlock className={classnames('layout', classNameModifier)} blocking={isLoading}>
        <section id="layout__header-extension"/>

        <section className="layout__container">
          <section id="layout__title-extension"/>

          {this.flashMessage}
          {children}
        </section>

        <section id="layout__footer-extension"/>

        {isAuthenticated && this.layoutSidemenu}

        <section id="layout__overlay-extension"/>
      </LoaderBlock>
    );
  }

  get layoutSidemenu() {
    const { history, layout } = this.props;
    return (
      <LayoutSidemenu
        history={history}
        isOpen={layout.showMenu}
        onLogout={this.props.logout}
        toggleMenu={this.toggleMenu}
      />
    );
  }

  get flashMessage() {
    const { flashMessageIsOpen, flashMessageModifier, flashMessageParam, flashMessageText } = this.props;
    const classNameFlashMessageIsOpen = flashMessageIsOpen ? 'layout__title-flash-message--is-open' : 'layout__title-flash-message--is-close';
    const flashMessageFormattedText = <FormattedMessage id={flashMessageText} values={flashMessageParam}/>;

    if (flashMessageText) {
      return (
        <div className={classnames('layout__flash-message o-container o-container--fluid', classNameFlashMessageIsOpen)}>
          <FlashMessage modifier={flashMessageModifier} text={flashMessageFormattedText}/>
        </div>
      );
    }

    return null;
  }

  private toggleMenu() {
    const { toggleMenu } = this.props;
    if (toggleMenu) toggleMenu();
  }
}

export const Layout = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    flashMessageIsOpen: state.flashMessageState.isOpen,
    flashMessageModifier: state.flashMessageState.modifier,
    flashMessageParam: state.flashMessageState.param,
    flashMessageText: state.flashMessageState.text,
    isAuthenticated: state.accountState.isAuthenticated,
    isLoading: state.layoutState.isLoading,
    layout: state.layoutState
  }), {
    logout,
    toggleMenu: LayoutActionCreators.toggleMenu.create
  }
)(LayoutContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Layout/Layout.tsx